// extracted by mini-css-extract-plugin
export var $animation_name = "QuantitySelector-module--$animation_name--7654f";
export var QuantitySelector = "QuantitySelector-module--QuantitySelector--ff728";
export var QuantitySelector__button = "QuantitySelector-module--QuantitySelector__button--950c1";
export var QuantitySelector__inActive = "QuantitySelector-module--QuantitySelector__inActive--33935";
export var QuantitySelector__value = "QuantitySelector-module--QuantitySelector__value--9e06a";